(() => {
  const form = document.querySelector('.m32__form');
	const selectField = document.querySelector('.m32__select');
	if (!form || !selectField) {
		return;
	}

	selectField.addEventListener('change', () => {
		const url = location.protocol + '//' + location.host + location.pathname + '?office-id=' + parseInt(selectField.value) + '#contact-info';
		window.location = encodeURI(url);
	});
})();
